module.exports = __webpack_public_path__ + "media/images/balance-product-picker-e7d3efc7c5f64a8f1e74cfec9f6ca296.png";